import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatZAR } from "@/lib/api";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && (user === false)) navigate("/login");
  }, [user, loading, navigate]);

  useEffect(() => {
    if (user && user.id) {
      api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
    }
  }, [user]);

  if (loading || user === null) return <div className="px-6 py-20 text-center small-label">Loading…</div>;
  if (!user) return null;

  return (
    <div data-testid="account-page" className="max-w-5xl mx-auto px-6 py-16">
      <p className="small-label">My account</p>
      <h1 className="font-serif text-4xl sm:text-5xl mt-3">Hello, {user.name}</h1>
      <div className="mt-2 flex items-center gap-3">
        <p className="text-stone text-sm">{user.email}</p>
        <button data-testid="logout-button" onClick={async () => { await logout(); navigate("/"); }} className="text-xs uppercase tracking-luxe underline">Sign out</button>
        {user.role === "admin" && <Link to="/admin" className="text-xs uppercase tracking-luxe underline">Admin</Link>}
      </div>

      <section className="mt-12">
        <p className="small-label">Order history</p>
        {orders.length === 0 ? (
          <div className="mt-6 border border-stone-line rounded-3xl p-10 text-center">
            <p className="text-stone">No orders yet.</p>
            <Link to="/shop" className="btn-outline mt-6 inline-flex">Start shopping</Link>
          </div>
        ) : (
          <div className="mt-6 space-y-4">
            {orders.map((o) => (
              <div key={o.id} className="border border-stone-line rounded-2xl p-5 flex items-center justify-between gap-4">
                <div>
                  <p className="font-medium">{o.order_number}</p>
                  <p className="small-label">{new Date(o.created_at).toLocaleDateString("en-ZA")}  ·  {o.items.length} items</p>
                </div>
                <div className="text-right">
                  <p className="font-medium">{formatZAR(o.total)}</p>
                  <p className="small-label capitalize">{o.fulfillment_status}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
